import api from './api';

/**
 * Fetch all FAQs (admin)
 */
export const fetchFaqs = async () => {
  const response = await api.get('/admin/faqs');
  return response.data;
};

/**
 * Create a new FAQ
 */
export const createFaq = async (data) => {
  const response = await api.post('/admin/faqs', data);
  return response.data;
};

/**
 * Update an FAQ
 */
export const updateFaq = async (id, data) => {
  const response = await api.put(`/admin/faqs/${id}`, data);
  return response.data;
};

/**
 * Delete an FAQ
 */
export const deleteFaq = async (id) => {
  const response = await api.delete(`/admin/faqs/${id}`);
  return response.data;
};
